import { Injectable } from '@angular/core';
import {APIService} from "./api.service";
import {Archive, ArchiveType} from "../interfaces/archive";
import { Paged } from "../interfaces/paged";

@Injectable({
  providedIn: 'root'
})
export class ArchiveService extends APIService {

  public async getArchives(type: ArchiveType = null, page: number = 1, filters = null, sorts:{col: string, dir: number}[] = []): Promise<Paged<Archive>>{
    return await this.post<any, Paged<Archive>>('/archives', {
      type,
      page,
      filters,
      sorts
    });
  }
}
